/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { parseUrl } from './urlHelpers';

export const NEAR_ME_BOT_ENABLED_FACET_PATH = '/b/near-me';

export const getBotEnabledFacetPath = (path?: string): string | undefined =>
  parseUrl(path ?? '').url.endsWith(NEAR_ME_BOT_ENABLED_FACET_PATH)
    ? NEAR_ME_BOT_ENABLED_FACET_PATH
    : undefined;

export const getShelfRequestStoreId = <StoreId extends string | number>(
  storeId: StoreId | undefined,
  isBot: boolean,
  botEnabledFacetPath?: string | null,
): StoreId | undefined =>
  isBot && botEnabledFacetPath === NEAR_ME_BOT_ENABLED_FACET_PATH ? undefined : storeId;
